module.exports = __webpack_public_path__ + "img/onboarding_guide4.2f6294cd.jpeg";